import { Typography, colors } from '@mui/material';

import data from '../../../../package.json';

export default function VersionFooter() {
  return (
    <Typography
      sx={{
        color: colors.grey[500],
        fontSize: 12,
        mb: 1,
      }}
      align='center'
      component='p'
    >
      Version {data.version}
    </Typography>
  );
}
